import { Redis } from '@upstash/redis'
import { getCookies, removeCookies } from 'cookies-next'
import { NextResponse } from 'next/dist/server/web/spec-extension/response'
import { NextRequest } from 'next/server'
import { useEffect, useState } from 'react'
import useSWR from 'swr'

const fetcher = (url) => fetch(url).then((r) => r.json())

export async function sessionMiddleware(req: NextRequest) {}

export async function authMiddleware(request: NextRequest) {
  const redis = new Redis({
    url: process.env.UPSTASH_REDIS_URL,
    token: process.env.UPSTASH_REDIS_REST_TOKEN,
  })

  const url = request.nextUrl.clone()
  url.pathname = '/auth'

  const cookie = request.cookies.get('pmt_session')

  if (!cookie) {
    return NextResponse.rewrite(url)
  }

  const redisRes = await redis.get(`session:${cookie}`)
  if (!redisRes) {
    return NextResponse.rewrite(url)
  }
}

export const useAuth = (profileFields = ['first_name', 'last_name']) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const { data: profile, error } = useSWR(
    profileFields && profileFields.length > 0 && isAuthenticated
      ? `/api/auth/me?fields=${profileFields.join(',')}`
      : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  useEffect(() => {
    const cookies = getCookies()
    if (cookies && cookies.pmt_session) {
      setIsAuthenticated(true)
    }
  }, [])

  return { isAuthenticated, setIsAuthenticated, profile }
}

export const removeCookie = () => {
  removeCookies('pmt_session')
}
